import React, { ComponentProps, FC } from 'react';
import { DatePicker as AntDatePicker } from 'antd';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';
import moment, { Moment } from 'moment';

import FormGroup, { IPropsText as IFormGroupTextProps } from '../components/FormGroup';

const MomentDatePicker = AntDatePicker.generatePicker<Moment>(momentGenerateConfig);

interface IDatePickerProps {
  name: string;
  valid?: boolean;
  onChange?: (event: { target: { name: string; value: any | null } }) => void;
  value?: Moment | null;
  defaultValue?: Moment | null; // Убедитесь, что defaultValue имеет правильный тип
}

export type IProps = IFormGroupTextProps &
  IDatePickerProps &
  Omit<ComponentProps<typeof MomentDatePicker>, 'onChange' | 'value' | 'defaultValue'>;

const DatePicker: FC<IProps> = ({
  label,
  tooltip,
  description,
  name,
  valid,
  value,
  defaultValue,
  onChange,
  ...props
}) => {
  const handleChange = (date: Moment | null) => {
    if (onChange) {
      onChange({ target: { name, value: date } });
    }
  };

  return (
    <FormGroup label={label} description={description} tooltip={tooltip} valid={valid}>
      <MomentDatePicker
        style={{ width: '100%' }}
        onChange={handleChange}
        value={value ? moment(value) : null}
        defaultValue={defaultValue ? moment(defaultValue) : null} // Убедитесь, что defaultValue правильно используется
        {...props}
      />
    </FormGroup>
  );
};

export default DatePicker;
